import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-500.png'


const _withScopeId = n => (_pushScopeId("data-v-238153d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-image-wrapper" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "帳票テンプレート"
      })
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}